import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { NgIf } from '@angular/common';
import { SessionStorageService } from '../../core/services/session-storage.service';
import { SubscriptionService } from '../../api/subscription.service';
import { executiveCodeValidator } from '../../shared/validators/mobile.validator';
import { storageKey } from '../../api/enum/storage.constants';

@Component({
  selector: 'app-verify-code',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, RouterLink, NgIf],
  templateUrl: './verify-code.component.html',
  styleUrl: './verify-code.component.scss'
})
export class VerifyCodeComponent implements OnInit {
  registerForm: FormGroup;
  isVerifying = false;
  verifyError: string | null = null;

  constructor(
    private fb: FormBuilder,
    private storage: SessionStorageService,
    private subscriptionService: SubscriptionService,
    private router: Router
  ) {
    this.registerForm = this.fb.group({
      executiveCode: ['', [Validators.required, executiveCodeValidator()]]
    });
  }

  ngOnInit(): void {}

  submit(): void {
    if (this.registerForm.invalid) return;
    const { executiveCode } = this.registerForm.getRawValue();
    this.isVerifying = true;
    this.verifyError = null;

    this.subscriptionService.verifyExecutiveCode(Number(executiveCode)).subscribe({
      next: () => {
        this.isVerifying = false;
        this.storage.set(storageKey.executiveCode, executiveCode);
        this.router.navigateByUrl('/institute');
      },
      error: (err) => {
        this.isVerifying = false;
        this.verifyError = err?.error?.message?.message ?? 'Invalid executive code. Please try again.';
      }
    });
  }
}
